module.exports = __webpack_public_path__ + "static/logo-930f13cbefbf247727bfb140370d1232.png";